import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pedEmpLiq'
})
export class PedEmpLiqPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value !== undefined) {
      return value.replace(/(\d{5})(\d{4})(\d{2})(\d{7})(\d{1})/g, '\$1.\$2.\$3.\$4\-\$5');
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipe/ped-emp-liq.pipe.ts